module.exports = __webpack_public_path__ + "img/arr_motivation.375c2e4e.svg";